import { Link } from '@lmc/design-system'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { IncidentCaseAttachment } from './caseAttachments'

const NameLink = ({ href, name }: { href: string; name: string }) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Link
      href={href}
      newTabLabel={t(
        incidentReportsConstants.CASE_V2_ATTACHMENTS_OPENS_IN_NEW_TAB
      )}
    >
      {name}
    </Link>
  )
}

/** A saved file by name: a link when its URL could be signed, else the name. */
const AttachmentLink = ({ file }: { file: IncidentCaseAttachment }) =>
  file.url ? <NameLink href={file.url} name={file.name} /> : file.name

/** A picked file not uploaded yet, opened from the browser's own copy. */
export const QueuedAttachmentLink = ({ file }: { file: File }) => {
  const [href, setHref] = useState<string | null>(null)

  useEffect(() => {
    const url = URL.createObjectURL(file)
    setHref(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  return href ? <NameLink href={href} name={file.name} /> : file.name
}

export default AttachmentLink
